export default "__VITE_ASSET__Bjz$NC0w__"